import React, { useCallback, useState, Fragment, useMemo } from "react";
import {
  Button,
  FormGroup,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import * as yup from "yup";
import { useFormik } from "formik";
import { addEmailInInterestList } from "../../store/api";
import { useParams } from "react-router-dom";
import { redirectToProductPage } from "../../helpers";
import { useOrganization } from "../../store/organization";
import { useOrderDetail } from "../../store/orderDetail";
import { PARTNERS_NAMES } from "../../utils/constants";

const UnservicedZip = (props) => {
  const { category, group } = useParams();
  const [isInProcessRequest, setInProcessRequest] = useState(false);
  const [isComplete, setComplete] = useState(false);

  const { data: organizationData } = useOrganization(
    (state) => state.organization
  );
  const { zip: manualZip, startOver } = useOrderDetail();

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    onSubmit: async (values) => {
      setInProcessRequest(true);

      const response = await onAddEmail(values.email);

      if (response?.isOk) {
        setComplete(true);
      }

      setInProcessRequest(false);
    },
    validationSchema: yup.object().shape({
      email: yup.string().email("Invalid Email").required("Email is required"),
    }),
  });

  async function onAddEmail(email) {
    return await addEmailInInterestList({
      email: email,
      zipPostal: manualZip,
      // ipAddress: null,
      organizationId: organizationData.organizationId,
      productId: category && group ? `${category}|${group}` : "freetrialride",
    });
  }

  const availableAreas = useMemo(() => {
    const detail = {
      title: "",
      states: "",
    };

    if (organizationData?.popupServicedAreasText) {
      const [title, states] =
        organizationData?.popupServicedAreasText.split(":");
      detail.title = `${title}`;
      detail.states = states;
    }

    return detail;
  }, [organizationData?.popupServicedAreasText]);

  const renderCompleteStep = useCallback(
    () => (
      <Fragment>
        <Typography
          variant="h5"
          fontWeight="700"
          className="tw-px-3 tw-my-3 tw-text-center"
        >
          Thanks for the submission
        </Typography>

        <Button
          fullWidth={true}
          variant="contained"
          type="submit"
          style={{ backgroundColor: "#333", height: "50px", marginTop: "25px", color: "#ffffff" }}
          onClick={startOver}
        >
          TRY NEW ZIP CODE
        </Button>

        <a
          type="submit"
          onClick={redirectToProductPage}
          style={{
            color: "#F05623",
            marginTop: "10px",
            textTransform: "capitalize",
            textDecoration: "underline",
            textAlign: "center",
            cursor: "pointer",
          }}
        >
          Back to {PARTNERS_NAMES[organizationData.friendlyNameUrl] ?? "Home Depot"}
        </a>

        <Typography
          variant="h6"
          fontWeight="700"
          fontSize={13}
          className="tw-pt-8 tw-text-center"
        >
          {availableAreas.title}:
        </Typography>

        <div className="serviced-areas tw-pb-8 tw-text-center tw-whitespace-pre-wrap">
          {availableAreas.states}
        </div>
      </Fragment>
    ),
    []
  );

  return (
    <div className="unserviced-zip tw-flex tw-flex-col tw-justify-center tw-px-8 md:tw-px-10 tw-pt-8">
      {!isComplete ? (
        <Fragment>
          <Typography
            variant="h5"
            fontWeight="700"
            className="sm:tw-px-12 tw-px-3 tw-my-3 tw-text-center"
          >
            {organizationData?.popupOutOfServiceHeaderText}
          </Typography>

          <Typography
            variant="p"
            className="tw-pt-5 tw-pb-5 tw-text-center tw-whitespace-pre-wrap"
          >
            {organizationData?.popupOutOfServiceCopy}
          </Typography>

          <form onSubmit={formik.handleSubmit}>
            <FormGroup>
              <TextField
                id="email"
                label="Your Email Address"
                variant="standard"
                name="email"
                value={formik.values.email}
                error={formik.touched.email && Boolean(formik.errors.email)}
                onChange={formik.handleChange}
              />
              {formik.errors.email && (
                <span style={{ color: "red", fontSize: "13px" }}>
                  {formik.errors.email}
                </span>
              )}
            </FormGroup>

            <Button
              fullWidth={true}
              variant="contained"
              type="submit"
              style={{
                backgroundColor: "#333",
                height: "50px",
                marginTop: "25px",
                color: "#ffffff",
              }}
            >
              {isInProcessRequest ? (
                <CircularProgress size={25} color="inherit" />
              ) : (
                "Submit"
              )}
            </Button>
          </form>

          <Typography
            color="#838383"
            fontSize={13}
            variant="p"
            className="tw-pt-5 tw-pb-8  tw-text-center"
          >
            Emails will be used exclusively for new location announcements.
          </Typography>
        </Fragment>
      ) : (
        renderCompleteStep()
      )}
    </div>
  );
};

UnservicedZip.propTypes = {};

export default UnservicedZip;
